import HeaderContentBlock from 'models/common/content/block/HeaderContentBlock';

export default class HeaderContentBlockService {
	toModel(block) {
		return new HeaderContentBlock(block);
	}
}
